export default __webpack_public_path__ + "static/media/myjourney-greentree-fruitnut.62d8c8fb.svg";